import { SignatureType } from "@evennt-tech/api-v2-core";
import { RawAttachmentFile } from "ts/api/attachmentFile";

export enum FontFamily {
  Playball = "Playball",
  Noteworthy = "Noteworthy",
  MarckScript = "Marck Script",
  Sofia = "Sofia",
}

export enum Colors {
  Black = "black",
  DarkBlue = "#002461",
  Blue = "#2979FF",
}

export type TabMap = {
  [key: number]: {
    type: SignatureType;
    file: RawAttachmentFile | null;
  };
};

export const ConfirmModalDetails = {
  title: "Your previous signature will be deleted. Replace it?",
  submitTitle: "Submit",
};

export const DiscardModalDetails = {
  title: "Do you want to discard changes?",
  submitTitle: "Discard anyway",
  subtitle: "Confirm",
  description: "Are you sure you want to close and lose your data?",
};

export const defaultSignatureText = "Create signature";

export type SinatureFormData = {
  name: string;
  role: string;
};

export const isEmptySignatureText = (text: string, defaultText: string) =>
  text.trim() === "" || text === defaultText;
